<template>
  <div id="top10-ranking">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li><router-link :to="{path: '/sbmptn'}">SBMPTN</router-link></li>
      <li class="active">Top 10</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">{{tryoutGroupName}}</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
            <div style="width:50%;">
              Daftar Siswa Top 10 UTBK
            </div>
          </div>
          <div class="panel-body">
            <ul class="nav nav-tabs">
              <li role="presentation" v-bind:class="{active: activeTab == 'IPA'}"><a :href="$router.fullpath" v-on:click="loadData('IPA')">IPA</a></li>
              <li role="presentation" v-bind:class="{active: activeTab == 'IPS'}"><a :href="$router.fullpath" v-on:click="loadData('IPS')">IPS</a></li>
            </ul>
            <table class="table">
              <thead>
                <th>Rank</th>
                <th>Name</th>
                <th>School</th>
                <th>Score</th>
                <th>Prodi 1</th>
              </thead>
              <tbody>
                <tr v-for="data in activeList" :key="data.id">
                  <td>{{data.rank}}</td>
                  <td>{{data.fullname.toUpperCase()}}</td>
                  <td>{{data.school}}</td>
                  <td>{{Math.round(data.score * 100) / 100}}</td>
                  <td>{{data.prodi_1}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TryoutService from '@/services/tryout.js'
export default {
  name: 'top10utbk',
  components: {

  },
  data: function() {
    return {
      top10ipa: [],
      top10ips: [],
      activeTab: '',
      activeList: []
    }
  },
  mounted: function() {
    var groupId = this.$route.query.group_id
    var context = this
    TryoutService.getTop10UtbkRank(groupId, function(result) {
      if (result.success) {
        context.top10ipa = result.data.ipa
        context.top10ips = result.data.ips
        context.activeList = context.top10ipa
        context.activeTab = 'IPA'
      }
    })
  },
  computed: {
    tryoutGroupName: {
      get: function() {
        return localStorage.getItem('rank_tryoutGroup_name')
      }
    }
  },
  methods: {
    loadData: function(category) {
      if(category == 'IPA') this.activeList = this.top10ipa
      else this.activeList = this.top10ips

      this.activeTab = category
    }
  }
}
</script>



// WEBPACK FOOTER //
// Top10Ranking.vue?479191c6